import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("二手车发票")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("登记证")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("身份证明")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("寄售合同")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("销售合同")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("认证报告")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保修报告")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("其它")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("证明")

import { ref } from "vue";
import viewUpload from "./previewModel.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  isTab: {
    type: Number,
    // default: 1,
    // required: true,
  },
  record: {
    type: Object,
    default: () => ({}),
    required: true,
  },
},
  setup(__props) {

const props = __props



const viewData = ref<any>({});
const isViewVisible = ref<boolean>(false);
const viewClose = () => {
  isViewVisible.value = false;
};

const handleInvoiceBtn = (parma: any, num: number) => {
  // const data = {
  //   1: {
  //     vinNo: parma.vehicleVinNo,
  //     operationType: 2,
  //   },
  //   0: {
  //     vinNo: parma.vinNo,
  //     operationType: 1,
  //   },
  // };
  viewData.value = {
    ucId: parma.ucId,
    type: num,
    applyTypeCode: parma.applyTypeCode,
    id: parma.id,
    types: props.isTab,
    //...data[props.isTab],
  };

  isViewVisible.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleInvoiceBtn(__props.record, 1))),
        disabled: !__props.record.invoice,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleInvoiceBtn(__props.record, 2))),
        disabled: !__props.record.registrationCertificate,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleInvoiceBtn(__props.record, 3))),
        disabled: !__props.record.identityDocument,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleInvoiceBtn(__props.record, 4))),
        disabled: !__props.record.consignmentContract,
        style: {"padding":"0","margin":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleInvoiceBtn(__props.record, 5))),
        disabled: !__props.record.salesContract,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleInvoiceBtn(__props.record, 6))),
        disabled: !__props.record.certificationReport,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (handleInvoiceBtn(__props.record, 7))),
        disabled: !__props.record.repairReport,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (handleInvoiceBtn(__props.record, 8))),
        disabled: !__props.record.otherSupporting,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_divider, {
        type: "vertical",
        style: {"margin":"0 2px"}
      }),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (handleInvoiceBtn(__props.record, 9))),
        disabled: !__props.record.prove && !__props.record.proveFileId,
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (isViewVisible.value)
      ? (_openBlock(), _createBlock(viewUpload, {
          key: 0,
          visible: isViewVisible.value,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((isViewVisible).value = $event)),
          isViewData: viewData.value,
          onCloseViewVisible: viewClose
        }, null, 8, ["visible", "isViewData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})